import { defineMessages } from 'react-intl';

// eslint-disable-next-line import/no-default-export
export default defineMessages({
    directDebit: {
        id: '_.your_company.payment_details.direct_debit',
        defaultMessage: 'Lastschriftverfahren'
    },
    automaticRepayment: {
        id: '_.your_company.payment_details.automatic_repayment',
        defaultMessage: 'Automatic repayments'
    },
    repaymentBackup: {
        id: '_.your_company.payment_details.repayment_backup',
        defaultMessage: 'Repayment backup'
    },
    disabled: {
        id: '_.your_company.payment_details.disabled',
        defaultMessage: 'Disabled'
    },
    edit: {
        id: '_.your_company.payment_details.edit',
        defaultMessage: 'Edit'
    }
});
